import axios from 'axios';
import authHeader from './auth-header';
import { stringify } from 'query-string';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5000/v1/';


class DataService {
  api() {
    return API_URL;
  }
  get(resource, params, headers = {}) {
    return axios.get(API_URL + resource + this.parseParams(params), { headers: { ...headers, ...authHeader() } });
  }
  delete(resource, params, headers = {}) {
    return axios.delete(API_URL + resource + this.parseParams(params), { headers: { ...headers, ...authHeader() } });
  }
  post(resource, body, headers = {}) {
    return axios.post(API_URL + resource, body, { headers: { ...headers, ...authHeader() } });
  }
  put(resource, body, headers = {}) {
    return axios.put(API_URL + resource, body, { headers: { ...headers, ...authHeader() } });
  }
  parseParams(params = {}) {
    var query = {}
    if (params.pagination) {
      const { page, pageSize } = params.pagination;
      query['page'] = page
      query['per_page'] = pageSize
    } else if (params.nopagination) {
      // do nothing
    } else {
      query['page'] = 1;
      query['per_page'] = 25;
    }
    if (params.ids) {
      console.log("ids", params.ids);
      query['ids'] = params.ids;
    }
    if (params.sort) {
      const sorts = Object.keys(params.sort);
      sorts.forEach(sort => {
        query['sort[field]'] = sort;
        query['sort[order]'] = params.sort[sort];
      });
    }
    if (params.filter) {
      const filters = Object.keys(params.filter);
      filters.forEach(filter => {
        query['filter[' + filter + ']'] = params.filter[filter]['val'];
        if (typeof params.filter[filter]['op'] != "undefined") {
          query['filterop[' + filter + ']'] = params.filter[filter]['op'];
        }
      });
    }
    let q = stringify(query);
    if (q.length > 0) {
      return "?" + q;
    }
    return ""
  }
}

export default new DataService();